// The 2x art scenes, one JSON file per region (file name = scene "id"). JSON can't be globbed
// by the bundler, so a new scene is one file here plus one import and one entry below. Order doesn't matter.
import kabukiCrossing from './kabuki-crossing.json';
import kabukiWest from './kabuki-west.json';
import kabukiNorth from './kabuki-north.json';
import kabukiEast from './kabuki-east.json';
import kabukiSouth from './kabuki-south.json';
import okuboWestA from './okubo-west-a.json';
import okuboWestB from './okubo-west-b.json';
import okuboEast from './okubo-east.json';
import nishiWest from './nishi-west.json';
import nishiEast from './nishi-east.json';
import sanctuaryMonastery from './sanctuary-monastery.json';
import sanctuaryTemple from './sanctuary-temple.json';
import sanctuaryMountain from './sanctuary-mountain.json';

export default [
  kabukiCrossing, kabukiWest, kabukiNorth, kabukiEast, kabukiSouth,
  okuboWestA, okuboWestB, okuboEast, nishiWest, nishiEast,
  sanctuaryMonastery, sanctuaryTemple, sanctuaryMountain,
];
